module.exports = __webpack_public_path__ + "img/car.82cf98af.svg";